interface ImportedGroupLink {
    id: string;
    parentGroupId: string | null;
}

interface GroupedImportedAccount {
    importedAccountGroupId: string | null;
}

export function rootImportedAccountGroupId(
    groupId: string | null,
    groups: ImportedGroupLink[],
): string | null {
    if (groupId == null) {
        return null;
    }
    const groupsById = new Map(groups.map((group) => [group.id, group]));
    let currentId: string | null = groupId;
    const visited = new Set<string>();
    while (currentId != null) {
        if (visited.has(currentId)) {
            return currentId;
        }
        visited.add(currentId);
        const group = groupsById.get(currentId);
        if (group == null || group.parentGroupId == null) {
            return currentId;
        }
        currentId = group.parentGroupId;
    }
    return groupId;
}

export function importedAccountGroupSubtreeIds(
    rootGroupId: string,
    groups: ImportedGroupLink[],
): Set<string> {
    const ids = new Set<string>([rootGroupId]);
    let grew = true;
    while (grew) {
        grew = false;
        for (const group of groups) {
            if (
                group.parentGroupId != null &&
                ids.has(group.parentGroupId) &&
                !ids.has(group.id)
            ) {
                ids.add(group.id);
                grew = true;
            }
        }
    }
    return ids;
}

interface AccountsInImportedAccountGroupSubtreeParams<
    T extends GroupedImportedAccount,
> {
    rootGroupId: string;
    groups: ImportedGroupLink[];
    accounts: T[];
}

export function accountsInImportedAccountGroupSubtree<
    T extends GroupedImportedAccount,
>({
    rootGroupId,
    groups,
    accounts,
}: AccountsInImportedAccountGroupSubtreeParams<T>): T[] {
    const groupIds = importedAccountGroupSubtreeIds(rootGroupId, groups);
    return accounts.filter(
        (account) =>
            account.importedAccountGroupId != null &&
            groupIds.has(account.importedAccountGroupId),
    );
}
